import Hotels from "../Pages/BrokerAgencies/Agencies/Hotels";

export const DictioneryPanel = {
    dashboard: {
        "fa": "داشبورد",
        "en": "Dashboard"
    },
    sell: {
        "fa": "فروش",
        "en": "sell"
    },
    sell1: {
        "fa": "فروش تور داخلی",
        "en": "Sell Domestic tour"
    },
    sell2: {
        "fa": "فروش تور خارجی",
        "en": "Sell foreign tours"
    },
    soldTours: {
        "fa": "تور های فروخته شده",
        "en": "Sold tours"
    },
    sellTour11: {
        "fa": "تک مقصده",
        "en": "Single destination"
    },
    sellTour12: {
        "fa": "چند مقصده",
        "en": "Multi destination"
    },
    sellTour13: {
        "fa": "گروهی",
        "en": "Group tour"
    },
    sellTour14: {
        "fa": "انفرادی",
        "en": "Solo tour"
    },
    sellTour21: {
        "fa": "تک مقصده",
        "en": "Single destination"
    },
    sellTour22: {
        "fa": "چند مقصده",
        "en": "Multi destination"
    },
    sellTour23: {
        "fa": "گروهی",
        "en": "Group tour"
    },
    sellTour24: {
        "fa": "انفرادی",
        "en": "Solo tour"
    },
    sellTourContracts: {
        "fa": "فروش ها",
        "en": "Sold"
    },
    sellTour: {
        "fa": "فروش از تور",
        "en": "Sell from tour"
    },
    sellWithoutTour: {
        "fa": "فروش بدون تور",
        "en": "Sell without tour"
    },
    soldHotels: {
        "fa": "هتل های فروخته شده",
        "en": "Sold hotels"
    },
    soldTourists: {
        "fa": "لیست مسافران",
        "en": "List of passengers"
    },
    baseInfo: {
        "fa": "تعاریف پایه",
        "en": "Basic definitions"
    },
    baseInfoTours: {
        "fa": "تور ها",
        "en": "Tours"
    },
    baseInfoHotels: {
        "fa": "هتل ها",
        "en": "Hotels"
    },
    baseInfoHotelsReq: {
        "fa": "خدمات (هتل و ...)",
        "en": "Services (hotel, etc.)"
    },
    baseInfoHotelsReqSended: {
        "fa": "هتل های درخواستی",
        "en": "Requested hotels"
    },
    baseInfoHotelsReqRecieved: {
        "fa": "هتل های درخواست شده",
        "en": "Requested hotels"
    },
    baseInfoBrokers: {
        "fa": "کارگزارها",
        "en": "Brokers"
    },
    baseInfoAgencies: {
        "fa": "آژانس ها",
        "en": "Agencies"
    },
    requestMain: {
        "fa": "درخواست ها",
        "en": "Requests"
    },
    requestCoop: {
        "fa": "همکاری با کارگزار",
        "en": "Cooperation with Brokers"
    },
    requestCoopAgency: {
        "fa": "همکاری با آژانس",
        "en": "Cooperation with Agency"
    },
    requestHotel: {
        "fa": "درخواست هتل",
        "en": "Hotel request"
    },
    requestHotelSended: {
        "fa": "درخواست‌های ارسالی هتل",
        "en": "Hotel sent request"
    },
    requestHotelRecieved: {
        "fa": "درخواست‌های دریافتی هتل",
        "en": "Hotel recieved request"
    },

    requestService: {
        "fa": "درخواست خدمات",
        "en": "Service request"
    },
    requestServiceSended: {
        "fa": "درخواست‌های ارسالی خدمات",
        "en": "Service sent request"
    },
    requestServiceRecieved: {
        "fa": "درخواست‌های دریافتی خدمات",
        "en": "Service recieved request"
    },


    reportBase: {
        "fa": "گزارش مدیریتی",
        "en": "Management report"
    },
    reportMonetary: {
        "fa": "گزارش مالی",
        "en": "Monetary report"
    },
    reportBaseArchiveTours: {
        "fa": "تورهای اجرا شده",
        "en": "Finished tours"
    },
    reportBaseActiveTours: {
        "fa": "تورهای جاری",
        "en": "Ongoing tours"
    },
    reportBasePassengers: {
        "fa": "مسافران",
        "en": "Passengers"
    },
    reportBaseTickets: {
        "fa": "فروش بلیط ها",
        "en": "Tickets sold"
    },

    reportBaseOperators: {
        "fa": "تعامل با کارگزاران",
        "en": "Interaction with operators"
    },
    reportBaseAgencies: {
        "fa": "تعامل با آژانس ها",
        "en": "Interaction with agencies"
    },
    reportBaseDrivers: {
        "fa": "رانندگان",
        "en": "Drivers"
    },
    reportBaseLeaders: {
        "fa": "لیدر ها",
        "en": "Leaders"
    },



    reportBaseIncoming: {
        "fa": "مسافران ورودی",
        "en": "incoming passengers"
    },
    reportBaseOutgoing: {
        "fa": "مسافران خروجی",
        "en": "incoming passengers"
    },
    reportBaseTrans: {
        "fa": "جابجایی مسافران",
        "en": "Transportation of passengers"
    },
    reportBaseTransDriver: {
        "fa": "مسافران من (راننده)",
        "en": "My passengers (Driver)"
    },
    reportBaseTransLeader: {
        "fa": "مسافران من (لیدر)",
        "en": "My passengers (Leader)"
    },
    reportBaseHotels: {
        "fa": "هتل های استفاده شده",
        "en": "Used hotels"
    },
    reportBaseTours: {
        "fa": "تور ها",
        "en": "Tours"
    },
    settings: {
        "fa": "تنظیمات",
        "en": "Settings"
    },
    settingsSubs: {
        "fa": "اشتراک ها",
        "en": "Subscriptions"
    },
    settingsContract: {
        "fa": "قرارداد ها",
        "en": "Contracts"
    },
    reportMonetarySold: {
        "fa": "فروش تور",
        "en": "Tour sales"
    },
    reportMonetaryArchiveTours: {
        "fa": "تورهای اجرا شده",
        "en": "Finished tours"
    },
    reportMonetaryTours: {
        "fa": "تورهای جاری",
        "en": "Ongoing tours"
    },
    reportMonetaryTickets: {
        "fa": "فروش بلیط ها",
        "en": "Tickets sold"
    },
    reportMonetaryHotels: {
        "fa": "هتل ها",
        "en": "Hotels"
    },
    reportMonetaryOpPerf: {
        "fa": "عملکرد کارگزاران",
        "en": "Operators' performance"
    },
    reportMonetaryPassengers: {
        "fa": "مسافرین",
        "en": "Passengers"
    },
    reportMonetarySellers: {
        "fa": "فروشندگان",
        "en": "Sellers"
    },
    reportMonetaryDrivers: {
        "fa": "رانندگان",
        "en": "Drivers"
    },
    reportMonetaryLeaders: {
        "fa": "لیدر ها",
        "en": "Leaders"
    },
    help: {
        "fa": "راهنما",
        "en": "Help"
    },
    dashboardDict: {
        editProfile: {
            "fa": "تنظیمات حساب کاربری",
            "en": "User account settings"
        },
        agencyName: {
            "fa": "نام آژانس",
            "en": "Agency Name"
        },
        brokerName: {
            "fa": "نام کارگزار",
            "en": "‌Broker Name"
        },
        agencyEnName: {
            "fa": "نام انگلیسی آژانس",
            "en": "Agency English Name"
        },
        brokerEnName: {
            "fa": "نام انگلیسی کارگزار",
            "en": "‌Broker English Name"
        },
        callNumber: {
            "fa": "شماره تماس",
            "en": "Call number"
        },
        email: {
            "fa": "آدرس ایمیل",
            "en": "Email address"
        },
        address: {
            "fa": "آدرس",
            "en": "Address"
        },
        city: {
            "fa": "شهر",
            "en": "City"
        },
        cityBase: {
            "fa": "شهر مبدا",
            "en": "Starting city "
        },
        cityDest: {
            "fa": "شهر مقصد",
            "en": "Destination city "
        },
        hotel: {
            "fa": "هتل",
            "en": "Hotel"
        },
        group: {
            "fa": "گروه",
            "en": "Group"
        },
        groupHotelNum: {
            "fa": "تعداد هتل در گروه",
            "en": "Number of hotels in the group"
        },
        country: {
            "fa": "کشور",
            "en": "Country"
        },
        countryBase: {
            "fa": "کشور مبدا",
            "en": "Starting country"
        },
        countryDest: {
            "fa": "کشور مقصد",
            "en": "Destination country"
        },
        locLat: {
            "fa": "عرض جغرافیایی",
            "en": "Latitude"
        },
        locLon: {
            "fa": "طول جغرافیایی",
            "en": "Longitude"
        },
        postal: {
            "fa": "کد پستی",
            "en": "Postal code"
        },
        mainPic: {
            "fa": "عکس اصلی",
            "en": "Main photo"
        },
        logoPic: {
            "fa": "لوگو",
            "en": "Logo"
        },
        description: {
            "fa": "توضیحات",
            "en": "Description"
        },
        webUrl: {
            "fa": "آدرس وبسایت",
            "en": "Website Url"
        },
        socialUrl: {
            "fa": "آدرس اینستاگرام",
            "en": "Instagram Url"
        },
        save: {
            "fa": "ذخیره",
            "en": "Save"
        },
        send: {
            "fa": "ارسال",
            "en": "Send"
        },
        uploadImage: {
            "fa": "برای انتخاب و اپلود کلیک کنید",
            "en": "Click to select and upload"
        },
        editAgency: {
            "fa": "ویرایش اطلاعات",
            "en": "Edit information"
        },
        agencyNoSubNotif: {
            "fa": "شما اشتراک فعالی ندارید",
            "en": "You do not have an active subscription."
        },
        buySubAgency: {
            "fa": "خرید اشتراک",
            "en": "Buy subscription"
        },
        brokersUnderContract:{
            "fa": "تعداد کارگزار های تحت قرارداد",
            "en": "Number of brokers under contract"
        },
        broker:{
            "fa": "کارگزار",
            "en": "Broker"
        },
        numberOfTours:{
            "fa": "تعداد تور ها",
            "en": "Number of tours"
        },
        tour:{
            "fa": "تور",
            "en": "Tour"
        },
        totalRevenue:{
            "fa": "درآمد کلی آژانس",
            "en": "Total revenue of the agency"
        },
        currency:{
            "fa": "ریال",
            "en": "IRR"
        },
        editAgencyPopup:{
            "fa": "ویرایش  اطلاعات آژانس",
            "en": "Edit agency information"
        },
        tourtype:{
            "fa": "نوع تور"   ,
            "en": "Tour Type"
        },
        facility:{
            "fa": " امکانات"   ,
            "en": "Facility Type"
        },
        facilityvalue:{
            "fa": " مقدار"   ,
            "en": "Facility Value"
        },
    },
    fileDict: {
        select: {
            "fa": "انتخاب کنید",
            "en": "Select a item"
        },
        filemanager: {
            "fa": "فایل منیجر",
            "en": "File manager"
        },
        uploadFile: {
            "fa": "آپلود فایل",
            "en": "Upload file"
        },
        selectFile: {
            "fa": "انتخاب فایل",
            "en": "Select file"
        },
        file: {
            "fa": "فایل",
            "en": "File"
        },
        name: {
            "fa": "نام",
            "en": "Name"
        },
        tag: {
            "fa": "تگ",
            "en": "Tag"
        },
        send: {
            "fa": "ارسال",
            "en": "Send"
        },
        filter: {
            "fa": "فیلتر",
            "en": "Filter"
        },
        type: {
            "fa": "نوع",
            "en": "Type"
        },
        notFound: {
            "fa": "موجود نیست",
            "en": "Not Found"
        },
        delete: {
            "fa": "حذف",
            "en": "Delete"
        },
        edit: {
            "fa": "ویرایش",
            "en": "Edit"
        },
        confirm: {
            "fa": "آیا مطمئن هستید؟",
            "en": "Are you sure?"
        },
    },
    tourlists: {
        "fa": "لیست تور ها",
        "en": "Tour lists"
    },
    tourlistsDict: {
        category: {
            "fa": "ترتیب:",
            "en": "Sort:"
        },
        editTour: {
            "fa": "اضافه کردن  تور جدید",
            "en": "Add new Tour"
        },
        directSell: {
            "fa": "فروش مستقیم",
            "en": "Direct sell"
        },
        sellTour: {
            "fa": "فروش تور",
            "en": "Sell tour"
        },
        tourdate: {
            "fa": "اضافه کردن  تاریخ تور جدید",
            "en": "Add new  Date Tour"
        },
        departureDate: {
            "fa": "تاریخ حرکت",
            "en": "Departure date"
        },
        dapartureTime: {
            "fa": "زمان حرکت",
            "en": "Departure time"
        },
    },
    drivers: {
        "fa": "لیست رانندگان",
        "en": "Drivers"
    },
    leaders: {
        "fa": "لیست لیدرها",
        "en": "Leaders"
    },
    packages: {
        "fa": "پکیج ها",
        "en": "Packages"
    },
    packagesDict : {
        editTour: {
            "fa": "ویرایش تور",
            "en": "Edit tour"
        },
        tourname: {
            "fa": "نام تور",
            "en": "Tour name"
        },
        tourDesc: {
            "fa": "توضیحات تور",
            "en": "Tour description"
        },
        tourImage: {
            "fa": "عکس تور",
            "en": "Tour picture"
        },
        tourImageDesc: {
            "fa": "برای انتخاب و اپلود کلیک کنید",
            "en": "Click to select and upload"
        },
        addNewDate: {
            "fa": "اضافه کردن تاریخ جدید",
            "en": "Add new date"
        },
        goDate: {
            "fa": "تاریخ رفت",
            "en": "Departure date"
        },
        backDate: {
            "fa": "تاریخ برگشت",
            "en": "Return date"
        },
        tourCapacity: {
            "fa": "ظرفیت تور",
            "en": "Tour capacity"
        },
        tourCurrency: {
            "fa": "ارز تور",
            "en": "Tour Currency"
        },
        tourCurrencyExtra: {
            "fa": "ارز اضافه تور",
            "en": "Extra tour currency"
        },
        tourDateDesc: {
            "fa": "توضیحات اضافه",
            "en": "Additional description"
        },
        tourDatePrice: {
            "fa": "شروع قیمت از",
            "en": "Price starts from"
        },
        tourDatePriceExtra: {
            "fa": "شروع قیمت اضافه از",
            "en": "Extra price starts from"
        },
        sellerAgency: {
            "fa": "آژانس فروشنده",
            "en": "Seller agency"
        },
        addTourDetail: {
            "fa": "اضافه کردن اطلاعات جدید",
            "en": "Add new information"
        },
        startTour: {
            "fa": "شروع تور",
            "en": "Start of tour"
        },
        endTour: {
            "fa": "پایان تور",
            "en": "End of tour"
        },
        hotelStar: {
            "fa": "تعداد ستاره",
            "en": "Number of stars"
        },
        tourDetailDesc: {
            "fa": "توضیحات",
            "en": "description"
        },
        tourAirline: {
            "en": "Airline name",
            "fa": "نام ایرلاین"
        },
        tourAirport: {
            "en": "departure airport Name",
            "fa": "نام فرودگاه مبدا"
        },
        tourdistAirport: {
            "en": "destination airport Name",
            "fa": "نام فرودگاه مقصد"
        },
        tourCargo: {
            "en": "Allowed cargo",
            "fa": "بار مجاز"
        },
        tourBus: {
            "en": "Bus type",
            "fa": "نوع اتوبوس"
        },
        tourTrain: {
            "en": "Train type",
            "fa": "نوع قطار"
        },
        tourShip: {
            "en": "Ship type",
            "fa": "نوع کشتی"
        },
        tourBoarding: {
            "en": "boarding place",
            "fa": "محل سوار شدن"
        },
        tourStart: {
            "en": "Origin",
            "fa": "مبدا"
        },
        tourEnd: {
            "en": "Destination",
            "fa": "مقصد"
        },
        addnewRoute: {
            "en": "Add new route",
            "fa": "افزودن مسیر جدید"
        },
        addnewTicket: {
            "en": "Add new ticket",
            "fa": "افزودن بلیط جدید"
        },
        addnewHotel: {
            "en": "Add new hotel",
            "fa": "افزودن هتل جدید"
        },
        addnewPlan: {
            "en": "Add new travel plan",
            "fa": "افزودن برنامه سفر جدید"
        },
        addnewService: {
            "en": "Add new service",
            "fa": "افزودن سرویس جدید"
        },
        addnewDocument: {
            "en": "Add new document",
            "fa": "افزودن مدارک جدید"
        },
        addnewDate: {
            "en": "Add new date",
            "fa": "افزودن تاریخ جدید"
        },
        addnewTag: {
            "en": "Add new tag or style",
            "fa": "افزودن تگ یا استایل جدید"
        },
        addnewPassenger: {
            "en": "Add new passenger",
            "fa": "افزودن مسافر جدید"
        },
        route: {
            "en": "route",
            "fa": "مسیر"
        },
        routes: {
            "en": "routes",
            "fa": "مسیر ها"
        },
        ticket: {
            "en": "ticket",
            "fa": "بلیط"
        },
        hotels: {
            "en": "hotels",
            "fa": "هتل ها"
        },
        hotel: {
            "en": "hotel",
            "fa": "هتل"
        },
        plan: {
            "en": "travel plan",
            "fa": "برنامه سفر"
        },
        plans: {
            "en": "travel plans",
            "fa": "برنامه سفر ها"
        },
        service: {
            "en": "service",
            "fa": "سرویس"
        },
        services: {
            "en": "services",
            "fa": "سرویس ها"
        },
        document: {
            "en": "Document",
            "fa": "مدارک"
        },
        documents: {
            "en": "Documents",
            "fa": "مدارک"
        },
        financial: {
            "en": "Financial",
            "fa": "مالی"
        },
        tag: {
            "en": "Tag or style",
            "fa": "تگ یا استایل",
        },
        date: {
            "en": "Date",
            "fa": "تاریخ"
        },
        dates: {
            "en": "Dates",
            "fa": "تاریخ ها"
        },
        routeIsOrigin: {
            "en": "Origin",
            "fa": "مبدا"
        },
        dayCount: {
            "en": "Day count",
            "fa": "تعداد روز"
        },
        deleteRouteConfirm: {
            "en": "Are you sure to delete this item?",
            "fa": "آیا از حذف این آیتم مطمئن هستید؟"
        },
        isMiddleRoute: {
            "en": "Middle route",
            "fa": "مسیر میانی"
        },
        stopoverRoute: {
            "en": "Stopover",
            "fa": "توقف"
        },
        ticketType: {
            "en": "Ticket type",
            "fa": "نوع بلیط"
        },
        ticketClass: {
            "en": "Ticket class",
            "fa": "کلاس بلیط"
        },
        ticketDepartureTime: {
            "en": "Ticket departure time",
            "fa": "زمان حرکت بلیط"
        },
        ticketDurationTime: {
            "en": "Ticket duration",
            "fa": "مدت زمان بلیط"
        },
        ticketBoardingArea: {
            "en": "Boarding area",
            "fa": "محل سوار شدن"
        },
        ticketDropofArea: {
            "en": "Drop-off location",
            "fa": "محل پیاده شدن"
        },
        ticketTransportProvider: {
            "en": "Transport provider",
            "fa": "شرکت حمل و نقل"
        },
        ticketTerminal: {
            "en": "Terminal",
            "fa": "ترمینال"
        },
        planDay: {
            "en": "Day",
            "fa": "روز"
        },
        planName: {
            "en": "Name",
            "fa": "نام"
        },
        planNameEn: {
            "en": "Name English",
            "fa": "نام انگلیسی"
        },
        planDesc: {
            "en": "Description",
            "fa": "توضیحات"
        },
        planDescEn: {
            "en": "Description English",
            "fa": "توضیحات انگلیسی"
        },
        planPic: {
            "en": "picture",
            "fa": "عکس"
        },
        serviceCount: {
            "en": "Count",
            "fa": "تعداد"
        },
        serviceType: {
            "en": "Service type",
            "fa": "نوع سرویس"
        },
        dateDeparture: {
            "en": "Departure Date",
            "fa": "تاریخ رفت"
        },
        timeDeparture: {
            "en": "Departure time",
            "fa": "زمان رفت"
        },
        dateReturn: {
            "en": "Return Date",
            "fa": "تاریخ برگشت"
        },
        timeReturn: {
            "en": "Return time",
            "fa": "زمان برگشت"
        },
        type: {
            "en": "Type",
            "fa": "نوع"
        },
        tags: {
            "en": "Tag or style",
            "fa": "تگ یا استایل"
        },
        passengers: {
            "en": "Passengers",
            "fa": "مسافران"
        },
        Single: {
            "en": "Single",
            "fa": "یک تخته"
        },
        Double: {
            "en": "Double",
            "fa": "دو تخته"
        },
        Adult: {
            "en": "Adult",
            "fa": "بزرگسال"
        },
        Chiled_With_Bed: {
            "en": "Chiled With Bed",
            "fa": "کودک با تخت"
        },
        Chiled_Without_Bed: {
            "en": "Chiled Without Bed",
            "fa": "کودک بدون تخت"
        },
        Baby: {
            "en": "Baby",
            "fa": "نوزاد"
        },

        NumberOf: {
            "en": "Number of",
            "fa": "تعداد"
        },
        PriceOfOne: {
            "en": "Price of one",
            "fa": "هزینه هر نفر"
        },


        editContractBase: {
            "en": "edit contract",
            "fa": "ویرایش پایه قرارداد"
        },
        roomBedType: {
            "en": "Bed type",
            "fa": "نوع تخت"
        },
        roomType: {
            "en": "Room type",
            "fa": "نوع اتاق"
        },
        fromCity: {
            "en": "From city",
            "fa": "از شهر"
        },
        toCity: {
            "en": "To city",
            "fa": "به شهر"
        },
        fromAddress: {
            "en": "From address",
            "fa": "از آدرس"
        },
        toAddress: {
            "en": "To address",
            "fa": "به آدرس"
        },
        english: {
            "en": "English",
            "fa": "انگلیسی"
        },
        creditor: {
            "en": "Creditor",
            "fa": "طلبکار"
        },
        debitor: {
            "en": "Debitor",
            "fa": "بدهکار"
        },
        startingPrice: {
            "fa": "شروع قیمت از",
            "en": "Starting price"
        },
        buy: {
            "fa": "خرید",
            "en": "Buy"
        },
        sendReq: {
            "fa": "ارسال درخواست",
            "en": "Send request"
        },
        totalPrice: {
            "fa": "قیمت کل",
            "en": "Total price"
        },
    },
    agencies: {
        "fa": "لیست آژانس ها",
        "en": "Agencies"
    },
    agenciesDict: {
        noItem: {
            "fa": "موردی انتخاب نشده است!",
            "en": "Item not selected!"
        },
        chat: {
            "fa": "شروع چت",
            "en": "Start chat"
        },
        searchAgain: {
            "fa": "جستجوی مجدد",
            "en": "Search again"
        }
    },
    hotels: {
        "fa": "هتل ها",
        "en": "Hotels"
    },
    hotelsDict: {
        hotels: {
            "fa": "هتل ها",
            "en": "Hotels"
        },
        ifHotel: {
            "fa": "اگر هتل مورد نظر خود را در لیست پیدا نکردید آن را اضافه کنید",
            "en": "If you don't find your desired hotel in the list, add it"
        },
        addHotel: {
            "fa": "افزودن هتل جدید",
            "en": "Add new hotel"
        },
        deleteHotel: {
            "fa": "آبا از حذف [hotelname] مطمئن هستید؟",
            "en": "Are you sure to delete [hotelname]?"
        },
        addHotelRoom: {
            "fa": "افزودن اتاق",
            "en": "Add hotel room"
        },
        price: {
            "fa": "قیمت",
            "en": "Price"
        },
        amount: {
            "fa": "تعداد",
            "en": "Amount"
        },
        fromDate: {
            "fa": "از تاریخ",
            "en": "From date"
        },
        toDate: {
            "fa": "تا تاریخ",
            "en": "To date"
        },
        addnewExp: {
            "fa": "افزودن قیمت در تاریخ",
            "en": "Add price in Date"
        },
        currency: {
            "fa": "ارز",
            "en": "currency"
        },
        formName: {
            "fa": "نام",
            "en": "Name"
        },
        formEnName: {
            "fa": "نام انگلیسی",
            "en": "English name"
        },
        formRoomType: {
            "fa": "نوع اتاق",
            "en": "Room Type"
        },
        formRoomInfo: {
            "fa": "اطلاعات",
            "en": "Info"
        },
        formRoomDesc: {
            "fa": "توضیحات",
            "en": "Description"
        },
        formCount: {
            "fa": "تعداد",
            "en": "Count"
        },
        formCountNow: {
            "fa": "تعداد موجود",
            "en": "In stock count"
        },
        formControl: {
            "fa": "کنترل",
            "en": "Control"
        },
        formControlActive: {
            "fa": "فعال",
            "en": "Active"
        },
        checkIn: {
            "fa": "چک این",
            "en": "Check in"
        },
        checkOut: {
            "fa": "چک اوت",
            "en": "Check out"
        },
    },
    backPage: {
        "fa": "مرحله قبل",
        "en": "Previous step"
    },
    nextPage: {
        "fa": "مرحله بعد",
        "en": "Next step"
    },
    nextSavePage: {
        "fa": "ذخیره و مرحله بعد",
        "en": "Save & Next step"
    },
    finishPage: {
        "fa": "تایید و ذخیره",
        "en": "ٰVerify & save"
    },
    access: {
        "fa": "دسترسی کاربران",
        "en": "Access"
    },
    wallet: {
        "fa": "کیف پول",
        "en": "Wallet"
    },
    walletDict: {
        removable: {
            "fa": "قابل برداشت",
            "en": "Removable"
        },
        scoreTotal: {
            "fa": "مجموع امتیاز",
            "en": "Total score"
        },
        all: {
            "fa": "موجودی",
            "en": "Balance"
        },
        recive: {
            "fa": "واریز به حساب",
            "en": "Deposit to the account"
        },
        charge: {
            "fa": "افزایش اعتبار کیف پول",
            "en": "Increase wallet credit"
        },
        transactions: {
            "fa": "لیست تراکنش ها",
            "en": "Transactions"
        },
        allIncome: {
            "fa": "مجموع واریز",
            "en": "Total deposit"
        },
        allWithdrawal: {
            "fa": "مجموع برداشت",
            "en": "Total withdrawal"
        },
        allRemaining: {
            "fa": "مجموع باقی مانده",
            "en": "Total remaining"
        },
        filterTitle: {
            "fa": "دسته بندی بر اساس:",
            "en": "Group by:"
        },
        filterAll: {
            "fa": "همه",
            "en": "All"
        },
        filterSearch: {
            "fa": "جستجو کنید ...",
            "en": "Search ..."
        },
        tableIncome: {
            "fa": "واریز",
            "en": "Deposit"
        },
        tableWithdrawal: {
            "fa": "برداشت",
            "en": "withdrawal"
        },
        score: {
            "fa": "امتیاز",
            "en": "Score"
        },
        tableDate: {
            "fa": "تاریخ",
            "en": "Date"
        },
        tableType: {
            "fa": "نوع",
            "en": "Type"
        },
        tableCharge: {
            "fa": "کارمزد",
            "en": "Charge"
        },
        tableSituation: {
            "fa": "وضعیت",
            "en": "Situation"
        },
        active: {
            "fa": "فعال",
            "en": "Active"
        },
    },
    accessDict: {
        add: {
            "fa": "اضافه کردن ادمین جدید",
            "en": "Add new admin"
        },
        addDriver: {
            "fa": "اضافه کردن راننده جدید",
            "en": "Add new driver"
        },
        addLeader: {
            "fa": "اضافه کردن لیدر جدید",
            "en": "Add new leader"
        },
        edit: {
            "fa": "ویرایش",
            "en": "Edit"
        },
        trash: {
            "fa": "حذف",
            "en": "Delete"
        },
        show: {
            "fa": "مشاهده",
            "en": "Show"
        },
        countryCity: {
            "fa": "شهرو/کشور:",
            "en": "City/Country:"
        },
        numberTours: {
            "fa": "تعداد تور های انجام شده:",
            "en": "Number of tours:"
        },
        Tour: {
            "fa": "تور",
            "en": "Tour"
        },
        deleteUser: {
            "fa": "آیا از حذف کاربر مطمئن هستید؟",
            "en": "Are you sure you want to delete the user?"
        },
        newUser: {
            "fa": "کاربر",
            "en": "User"
        },
        newDriver: {
            "fa": "راننده",
            "en": "Driver"
        },
        newLeader: {
            "fa": "لیدر",
            "en": "Leader"
        },
        email: {
            "fa": "ایمیل",
            "en": "Email"
        },
        name: {
            "fa": "نام و نام خانوادگی",
            "en": "First name & last name"
        },
        accesses: {
            "fa": "دسترسی ها",
            "en": "Access"
        },
    },
    chats: {
        "fa": "صفحه چت",
        "en": "Chats"
    },
    chatsDict: {
        sendMessagePlaceholder: {
            "fa": "پیام ...",
            "en": "Message ..."
        },
        noItem: {
            "fa": "برای شروع یک پیام ارسال کنید!",
            "en": "Send a message to get started!"
        },
    },
    campaigns: {
        "fa": "مدریت آگهی ها",
        "en": "Campaigns"
    },
    brokers: {
        "fa": "لیست کارگزاران",
        "en": "Brokers"
    },
    tourists: {
        "fa": "لیست مسافران",
        "en": "Tourists"
    },
    soldPackages: {
        "fa": "پکیج و تور های فروخته شده",
        "en": "Sold packages & tours "
    },
    incomeTourist: {
        "fa": "مسافران ارجاعی",
        "en": "Referral passengers "
    },
    touristsDict: {
        dateFilter: {
            "fa": "فیلتر تاریخ",
            "en": "Date filtrer"
        },
        typeofTicket: {
            "fa": "نوع مسیر",
            "en": "Type of route"
        },
        selected: {
            "fa": "انتخاب شده",
            "en": "Selected"
        },
        selectTour: {
            "fa": "یک تور انتخاب کنید",
            "en": "Select a tour"
        },
        newList: {
            "fa": "لیست جدید",
            "en": "New list"
        },
        Tour: {
            "fa": "تور",
            "en": "Tour"
        },
        Date: {
            "fa": "تاریخ",
            "en": "Date"
        },
        sellerPersonel: {
            "fa": "فروشنده",
            "en": "Seller"
        },
        Hotel: {
            "fa": "هتل",
            "en": "Hotel"
        },
        allHotels: {
            "fa": "همه هتل ها",
            "en": "All hotels"
        },
        HotelRooms: {
            "fa": "اتاق های هتل",
            "en": "Hotel Rooms"
        },
        selectDate: {
            "fa": "انتخاب تاریخ",
            "en": "Select date"
        },
        addNewDate: {
            "fa": "افزودن تاریخ جدید",
            "en": "Add new date"
        },
        addNewPerson: {
            "fa": "اضافه کردن مسافر جدید",
            "en": "Add new passenger"
        },
        addNewHotelRoom: {
            "fa": "اضافه کردن اتاق جدید",
            "en": "Add new hotel room"
        },
        addNewPartialPrice: {
            "fa": "اضافه کردن پرداخت جدید",
            "en": "Add new payment"
        },
        personID: {
            "fa": "کد مسافر",
            "en": "Passenger ID"
        },
        personName: {
            "fa": "نام و نام خانوادگی",
            "en": "First name & last name"
        },
        personFName: {
            "fa": "نام",
            "en": "First name"
        },
        personLName: {
            "fa": "نام خانوادگی",
            "en": "Last name"
        },
        personFNameEn: {
            "fa": "نام به انگلیسی",
            "en": "First name in English"
        },
        personLNameEn: {
            "fa": "نام خانوادگی به انگلیسی",
            "en": "Last name in English"
        },
        personCompanyNum: {
            "fa": "تعداد",
            "en": "No. passengers"
        },
        personNationalID: {
            "fa": "کد ملی",
            "en": "National ID"
        },
        personBirthday: {
            "fa": "تاریخ تولد",
            "en": "Birthdate"
        },
        personAgeGroup: {
            "fa": "رده سنی",
            "en": "Age group"
        },
        personPassportID: {
            "fa": "شماره پاسپورت",
            "en": "Passport number"
        },
        personPassportExp: {
            "fa": "تاریخ انقضای پاسپورت",
            "en": "Expiry date of passport"
        },
        personMobile: {
            "fa": "موبایل",
            "en": "Mobile"
        },
        personEmail: {
            "fa": "ایمیل",
            "en": "Email"
        },
        personMain: {
            "fa": "سرپرست",
            "en": "supervisor"
        },
        personSec: {
            "fa": "مسافر همراه",
            "en": "Accompanying passenger"
        },
        personelMain: {
            "fa": "پرسنل",
            "en": "Personel"
        },
        personelMainName: {
            "fa": "نام",
            "en": "Name"
        },
        noFilter: {
            "fa": "برای مشاهده، فیلتر کشور و شهر را پر کنید",
            "en": "To view, fill in the country and city filter"
        },
        index: {
            "fa": "ردیف",
            "en": "Index"
        },
        select: {
            "fa": "انتخاب",
            "en": "select"
        },
        Name: {
            "fa": "نام",
            "en": "Name"
        },
        dateDepart: {
            "fa": "تاریخ رفت",
            "en": "Departure date"
        },
        dateReturn: {
            "fa": "تاریخ برگشت",
            "en": "Return date"
        },
        hotelRoom: {
            "fa": "اتاق",
            "en": "Room"
        },
        hotelExtras: {
            "fa": "اضافات",
            "en": "Extras"
        },
        hotelServices: {
            "fa": "سرویس ها",
            "en": "Services"
        },
        hotelMeals: {
            "fa": "غذاها",
            "en": "Meals"
        },
        hotelRoomInfo: {
            "fa": "اطلاعات اتاق",
            "en": "Room info"
        },
        priceCount: {
            "fa": "تعداد",
            "en": "Count:"
        },
        priceCount: {
            "fa": "تعداد",
            "en": "Count:"
        },
        checkinDate: {
            "fa": "تاریخ ورود",
            "en": "Checkin date"
        },
        checkoutDate: {
            "fa": "تاریخ خروج",
            "en": "Checkout date"
        },
        passengerCount: {
            "fa": "تعداد مسافر",
            "en": "Passenger count"
        },
        pricePerPerson: {
            "fa": "قیمت هر نفر",
            "en": "Price per person"
        },
        flightNo: {
            "fa": "شماره پرواز",
            "en": "Flight number"
        },
        TicketNo: {
            "fa": "شماره بلیط",
            "en": "Ticket number"
        },
        priceTickets: {
            "fa": "جمع قیمت بلیط ها",
            "en": "Total price of tickets"
        },
        priceHotels: {
            "fa": "جمع قیمت اتاق ها",
            "en": "Total price of rooms"
        },
        pricePartial: {
            "fa": "مقدار",
            "en": "Price"
        },
        priceDate: {
            "fa": "تاریخ",
            "en": "Date"
        },
        priceDesc: {
            "fa": "توضیحات",
            "en": "Description"
        },
        priceType: {
            "fa": "نوع پرداخت",
            "en": "Payment type"
        },
        priceTotal: {
            "fa": "قیمت کل",
            "en": "Price total"
        },
        noPasenger: {
            "fa": "تعداد مسافرین",
            "en": "Number of passengers"
        },
        noPasengerNotSend: {
            "fa": "اطلاعات ارسال نشده",
            "en": "Information not sent"
        },
        noPasengerNotSendToBroker: {
            "fa": "ارسال اطلاعات مسافران",
            "en": "Send passenger information"
        },
        pasenger: {
            "fa": "مسافر",
            "en": "Pasenger"
        },
        personSecTable: {
            "fa": "به همراه",
            "en": "Along with"
        },
        pasengerNoTable: {
            "fa": "نفر دیگر",
            "en": "other person"
        },
        actions: {
            "fa": "اکشن ها",
            "en": "Actions"
        },
        editTouristData: {
            "fa": "ویرایش",
            "en": "Edit"
        },
        addPersonel: {
            "fa": "اضافه کردن پرسنل",
            "en": "Add personel"
        },
        infoPassenger: {
            "fa": "اطلاعات مسافر",
            "en": "Passenger Info"
        },
        passengerDriver: {
            "fa": "راننده",
            "en": "Driver"
        },
        passengerLeader: {
            "fa": "لیدر",
            "en": "Leader"
        },
        passengerTickets: {
            "fa": "بلیط ها",
            "en": "Tickets"
        },
        passengerPakcages: {
            "fa": "پکیج",
            "en": "Package"
        },
        passengerAddPakcage: {
            "fa": "افزودن پکیج",
            "en": "Add package"
        },
        passengerAddPersonel: {
            "fa": "افزودن پرسنل",
            "en": "Add personel"
        },
        passengerTicketsType: {
            "fa": "نوع",
            "en": "Type"
        },
        passengerTicketsDate: {
            "fa": "تاریخ",
            "en": "Date"
        },
        passengerTicketsTime: {
            "fa": "زمان",
            "en": "Time"
        },
        passengerHotels: {
            "fa": "هتل ها",
            "en": "Hotels"
        },
        passengerRoom: {
            "fa": "اتاق",
            "en": "Room"
        },
        passengerPakcageName: {
            "fa": "نام پکیج",
            "en": "Package name"
        },
        passengerPakcagePrice: {
            "fa": "قیمت",
            "en": "Price"
        },
        passengerPersonel: {
            "fa": "پرسنل",
            "en": "Personel"
        },
    },
    tourname: {
        "fa": "نام تور",
        "en": "Tour Name"
    },
    tournameen: {
        "fa": "نام تور انگلیسی",
        "en": "Tour Name English"
    },
    tourdesc: {
        "fa": "شرح  تور",
        "en": "Tour DEscription"
    },
    tourdescen: {
        "fa": "شرح  تور انگلیسی",
        "en": "Tour Description English"
    },
    tourprice: {
        "fa": "قیمت  تور",
        "en": "Tour Price"
    },
    tourComissionPrice: {
        "fa": "کمیسیون ثابت",
        "en": "Fixed commission"
    },
    tourComissionPercent: {
        "fa": "کمیسیون درصدی",
        "en": "Percentage commission"
    },
    tourcapacity: {
        "fa": "ظرفیت  تور",
        "en": "Tour Capacity"
    },
    Departure_Date: {
        "fa": "تاریخ  رفت",
        "en": "Departure Date"
    },
    Return_Date: {
        "fa": "تاریخ  برگشت",
        "en": "Return Date"
    },
    addtourdate: {
        "fa": "اضافه کردن تاریخ تور  ",
        "en": "Add New Date Tour"
    },
    addtourdetail: {
        "fa": "اضافه کردن جزئیات تور  ",
        "en": "Add New Detail Tour"
    },
    addtourhotel: {
        "fa": "اضافه کردن هتل های تور  ",
        "en": "Add New Hotels Tour"
    },
    addtourgroup: {
        "fa": "اضافه کردن گروه به تور  ",
        "en": "Add New Group Tour"
    },
    broker: {
        "fa": "کارگزار",
        "en": "broker",
    },
    hotel: {
        "fa": "هتل",
        "en": "hotel",
    },
    reports: {
        "fa": "گزارش ها",
        "en": "Reports"
    },
    reportsDict: {
        passengerIntry: {
            "fa": "گزارش جابه‌جایی مسافر",
            "en": "Passenger displacement report"
        },
        passengerEnterance: {
            "fa": "گزارش مسافر ورودی",
            "en": "Passenger enterance report"
        },
        passengerDeparture: {
            "fa": "گزارش مسافر خروجی",
            "en": "Passenger departure report"
        },
        passengerIntryPers: {
            "fa": "گزارش جابه‌جایی مسافر برای پرسنل",
            "en": "Passenger displacement report for personel"
        },
        hotelIntry: {
            "fa": "گزارش هتل های فروخته شده",
            "en": "Report of sold hotels"
        },
        hotelVoucher: {
            "fa": "ووچر هتل",
            "en": "Hotel Voucher"
        },
        situation: {
            "fa": "وضعیت",
            "en": "Situation"
        },
        situationAll: {
            "fa": "همه",
            "en": "all"
        },
        situationConfirmed: {
            "fa": "تایید شده",
            "en": "Confirmed"
        },
        situationNotConfirmed: {
            "fa": "در انتظار تایید",
            "en": "Awaiting approval"
        },
        situationRejected: {
            "fa": "رد شده",
            "en": "Rejected"
        },
        notFound: {
            "fa": "موردی یافت نشد",
            "en": "Nothing found"
        },
        NoName: {
            "fa": "ردیف",
            "en": "No"
        },
        agencyName: {
            "fa": "نام آژانس",
            "en": "Agency name"
        },
        hotelName: {
            "fa": "نام هتل",
            "en": "Hotel name"
        },
        personelNumber: {
            "fa": "تعداد پرسنل",
            "en": "Number of personnel"
        },
        personelSit: {
            "fa": "پرسنل/وضعیت",
            "en": "Personnel/situation"
        },
        roomName: {
            "fa": "نام اتاق",
            "en": "Room name"
        },
        checkin: {
            "fa": "ورود",
            "en": "Check-in"
        },
        checkout: {
            "fa": "خروج",
            "en": "Check-out"
        },
        count: {
            "fa": "تعداد",
            "en": "Count"
        },
        price: {
            "fa": "قیمت",
            "en": "Price"
        },
        situation: {
            "fa": "وضعیت",
            "en": "Situation"
        },
        action: {
            "fa": "اکشن",
            "en": "Action"
        },
        actionDetail: {
            "fa": "اطلاعات",
            "en": "Info"
        },
        verifyHotel: {
            "fa": "تایید",
            "en": "Verify"
        },
        toNotConfirmedHotel: {
            "fa": "به تایید نشده",
            "en": "To not confirmed"
        },
        rejectHotel: {
            "fa": "رد کردن",
            "en": "Reject"
        },
        rejectReasonHotel: {
            "fa": "دلیل رد کردن",
            "en": "Rejecting reason"
        },
        sendBrokerReq: {
            "fa": "ارسال درخواست",
            "en": "Send request"
        },
        sendBrokerReqReject: {
            "fa": "رد درخواست",
            "en": "Reject request"
        },
        sendBrokerReqConfirm: {
            "fa": "تایید درخواست",
            "en": "Confirm request"
        },
        sendBrokerReqShow: {
            "fa": "مشاهده درخواست",
            "en": "Show request"
        },
        sendBrokerReqRejected: {
            "fa": "رد شده",
            "en": "Rejected"
        },
        sendBrokerReqRejected: {
            "fa": "رد شده",
            "en": "Rejected"
        },
        sendBrokerReqSent: {
            "fa": "ارسال شده",
            "en": "Sent"
        },
        sendBrokerReqConfirmed: {
            "fa": "تایید شده",
            "en": "Confirmed"
        },
        sendBrokerReqText: {
            "fa": "متن درخواست",
            "en": "Request text"
        },
        ticketType: {
            "fa": "نوع بلیط",
            "en": "Ticket type"
        },
        ticketTransfereType: {
            "fa": "مسیر",
            "en": "route"
        },
        parentUser: {
            "fa": "مسافر سرپرست",
            "en": "Main passenger"
        },
        dateFlight: {
            "fa": "تاریخ بلیط",
            "en": "Ticket date"
        },
        timeFlight: {
            "fa": "زمان بلیط",
            "en": "Ticket time"
        },
        passengerCount: {
            "fa": "تعداد مسافرین",
            "en": "Passenger count"
        },
        flightNo: {
            "fa": "شماره بلیط",
            "en": "Ticket Number"
        },
        airline: {
            "fa": "ایرلاین",
            "en": "Airline"
        },
        depAirport: {
            "fa": "ترمینال مبدا",
            "en": "Departure terminal"
        },
        desAirport: {
            "fa": "ترمینال مقصد",
            "en": "Destination terminal"
        },
        hotelName: {
            "fa": "نام هتل",
            "en": "Hotel name"
        },
        DateIssue: {
            "fa": "تاریخ:",
            "en": "date:"
        },
        fromDate: {
            "fa": "از تاریخ:",
            "en": "From date:"
        },
        toDate: {
            "fa": "تا تاریخ:",
            "en": "To date:"
        },
        PNR: {
            "fa": "شماره مسافر:",
            "en": "PNR:"
        },
        TourID: {
            "fa": "کد تور:",
            "en": "Tour ID:"
        },
        NumberOfRooms: {
            "fa": "تعداد اتاق:",
            "en": "Number of rooms:"
        },
        Name: {
            "fa": "نام",
            "en": "Name"
        },
        mobile: {
            "fa": "موبایل",
            "en": "Mobile"
        },
        email: {
            "fa": "ایمیل",
            "en": "Email"
        },
        address: {
            "fa": "آدرس",
            "en": "Address"
        },
        Callnumber: {
            "fa": "تلفن تماس",
            "en": "Call Number"
        },
    },
    settings: {
        "fa": "تنظیمات",
        "en": "Settings"
    },
    invite: {
        "fa": "دعوت از دوستان",
        "en": "Invite friends"
    },
    inviteDict: {
        inviteLink: {
            "fa": "لینک اختصاصی شما",
            "en": "Your exclusive link"
        },
        copylink: {
            "fa": "کپی لینک",
            "en": "Copy link"
        },
        copylinkOkay: {
            "fa": "لینک کپی شد",
            "en": "The link was copied"
        },
        scoreTotal: {
            "fa": "مجموع امتیازات",
            "en": "Total score"
        },
        inviteTotal: {
            "fa": "تعداد دوستان",
            "en": "Number of friends"
        },
    },
    ads: {
        "fa": "تبلیغات",
        "en": "advertisement"
    },
    notifOn: {
        "fa": "روشن کردن نوتیفیکیشن",
        "en": "Turn on notification"
    },
    notifOff: {
        "fa": "خاموش کردن نوتیفیکیشن",
        "en": "Turn off notification"
    },
    addAgency: {
        "fa": "ثبت نام آژانس جدید",
        "en": "New agency registration"
    },
    saveData: {
        "fa": "ذخیره اطلاعات",
        "en": "Save information"
    },
    addBroker: {
        "fa": "ثبت نام کارگزار جدید",
        "en": "New Broker registration"
    },
    typesTransfereDict: {
        type: {
            "fa": "نوع مسیر",
            "en": "Transfer type"
        },
        type1: {
            "fa": "ورودی",
            "en": "Entrance"
        },
        type2: {
            "fa": "بین شهری",
            "en": "Intercity"
        },
        type3: {
            "fa": "خروجی",
            "en": "Departure"
        },
    },
    filterDict: {
        country: {
            "fa": "کشور",
            "en": "Country"
        },
        city: {
            "fa": "شهر",
            "en": "City"
        },
        type: {
            "fa": "نوع",
            "en": "Type"
        },
        name: {
            "fa": "نام",
            "en": "Name"
        },
    },
    tableDict: {
        index: {
            "fa": "ردیف",
            "en": "Index"
        },
        registerContract: {
            "fa": "ثبت پیش قرارداد",
            "en": "register Pre-contract registr"
        },
        print: {
            "fa": "پرینت",
            "en": "Print"
        },
        sendHotelReq: {
            "fa": "ارسال درخواست رزرو هتل",
            "en": "Send a hotel reservation request"
        },
        sendToBroker: {
            "fa": "ارسال اطلاعات به کارگزار",
            "en": "Send information to the broker"
        },
        agenciesCon: {
            "fa": "درخواست های همکاری",
            "en": "Cooperation requests"
        },
        agency_name: {
            "fa": "نام آژانس",
            "en": "Agency Name"
        },
        agency_contracted: {
            "fa": "تحت قرارداد",
            "en": "Contracted"
        },
        agency_chat: {
            "fa": "شروع چت",
            "en": "Start chat"
        },
        agency_req: {
            "fa": "ارسال درخواست",
            "en": "Send request"
        },
        broker_name: {
            "fa": "نام کارگزار",
            "en": "Broker Name"
        },
        hotelName: {
            "fa": "نام هتل",
            "en": "Hotel name"
        },
        hotelroomName: {
            "fa": "نوع اتاق",
            "en": "Room type"
        },
        currency: {
            "fa": "ارز",
            "en": "Currency"
        },
        fromPrice: {
            "fa": "قیمت از",
            "en": "Price from"
        },
        price: {
            "fa": "قیمت",
            "en": "Price"
        },
        count: {
            "fa": "تعداد",
            "en": "Count"
        },
        countMax: {
            "fa": "حداکثر تعداد",
            "en": "Maximum count"
        },
        dateFrom: {
            "fa": "از تاریخ",
            "en": "From Date"
        },
        dateTo: {
            "fa": "تا تاریخ",
            "en": "To Date"
        },
        situation: {
            "fa": "وضعیت",
            "en": "Situation"
        },
        reject: {
            "fa": "رد",
            "en": "Reject"
        },
        confirm: {
            "fa": "تایید",
            "en": "Confirm"
        },
        cancel: {
            "fa": "کنسل",
            "en": "Cancel"
        },
        noDay: {
            "fa": "تعداد روز",
            "en": "Number of days"
        },
        active: {
            "fa": "فعال",
            "en": "Active"
        },
        disabled: {
            "fa": "غیر فعال",
            "en": "Inactive"
        },
        
    },
    contractsDict: {
        title: {
            "fa": "قرارداد ها",
            "en": "Contracts"
        },
        addNewContract: {
            "fa": "قرارداد جدید",
            "en": "New Contract"
        },
        contract: {
            "fa": "قرارداد",
            "en": "Contract"
        },
        contractAddAndShow: {
            "fa": "ثبت پیش قرارداد و نمایش",
            "en": "Pre-contract registration and display"
        },
    },
    subsDict: {
        name: {
            "fa": "نام پکیج",
            "en": "Package name"
        },
        desc: {
            "fa": "توضیحات",
            "en": "Description"
        },
        title: {
            "fa": "اشتراک ها",
            "en": "Subscriptions"
        },
        noSubs: {
            "fa": "شما اشتراک فعالی ندارید",
            "en": "You do not have an active subscription"
        },
        remainingDays: {
            "fa": "روز از اعتبار شما باقی مانده",
            "en": "Days left on your credit."
        },
        buySub: {
            "fa": "خرید اشتراک",
            "en": "Buy subscription"
        },
        selectSub: {
            "fa": "اشتراک را انتخاب کنید",
            "en": "Select Subscription"
        },
        packagePrice: {
            "fa": "قیمت پکیج",
            "en": "Package price"
        },
        discount2: {
            "fa": "تخفیف",
            "en": "Discount"
        },
        payable: {
            "fa": "قابل پرداخت",
            "en": "Payable"
        },
        discount: {
            "fa": "کد تخفیف",
            "en": "Discount code"
        },
        applyDis: {
            "fa": "اعمال کد تخفیف",
            "en": "Apply discount code"
        },
        pay: {
            "fa": "پرداخت",
            "en": "Pay"
        },
        amount: {
            "fa": "مقدار",
            "en": "Amount"
        },
        currency: {
            "fa": "ارز",
            "en": "Currency"
        },
        payOther: {
            "fa": "قرارداد شما ذخیره شد و برای پرداخت مبلغ آن با پشتیبانی تماس حاصل فرمایید",
            "en": "Your contract has been saved and please contact support to pay the payments."
        },
    }
}